// CONSTANTS are all caps.
const NS = 'ProductCarousel';
const CLS = 'productCarousel';
const BLK = '.' + CLS + '-';
const SLIDE_TO_SHOW = 4;
const CLS_IS_INITED = 'is-initialized';

import * as utils from '../../../../global/js/utils';

export class ProductCarousel {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderWrap = this.$el.find(`.${CLS}-sliderWrap`);
		this.$btnNext = this.$el.find(`.${CLS}-btnWrapNext`);
		this.$btnPrev = this.$el.find(`.${CLS}-btnWrapPrev`);

		this.slidesToShow = this.$el.data('slidesToShow');
		if (this.slidesToShow && !isNaN(this.slidesToShow)) {
			this.slidesToShow = parseInt(this.slidesToShow);
		}

		this.initSwiper();
	}

	initSwiper() {
		// from mobile to desktop
		let slidesToShow = this.slidesToShow || SLIDE_TO_SHOW;
		let slidesToShowLG = slidesToShow - 1 || 1;

		const swiper = new Swiper(this.$sliderWrap[0], {
			init: false,
			slidesPerView: 2.25,
			spaceBetween: 16,
			freeMode: true,
			mousewheel: true,
			navigation: {
				nextEl: this.$el.find('.swiper-button-next')[0],
				prevEl: this.$el.find('.swiper-button-prev')[0],
			},
			scrollbar: this.isMini ? false : {
				el: this.$sliderWrap.find('.swiper-scrollbar')[0],
				draggable: true,
			},
			breakpoints: {
				[utils.BREAKPOINT.MD]: {
					slidesPerView: 3,
				},
				[utils.BREAKPOINT.LG]: {
					slidesPerView: slidesToShowLG > 4 ? 4 : slidesToShowLG, // force to have 4 slides
				},
				[utils.BREAKPOINT.XL]: {
					slidesPerView: slidesToShow > 5 ? 5 : slidesToShow, // force to have 5 slides
				},
			}
		});

		swiper.on('init', () => {
			this.$el.addClass(CLS_IS_INITED);
		});

		swiper.init();
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/productCarousel/js/productCarousel.js